import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { DlsIconModule } from '@zelis/dls/icons';
import { MatIconModule } from '@angular/material/icon';
import {
  ExpansionPanelHeaderComponent,
  ExpansionPanelRightIconDirective,
} from './expansion-panel-header-content/expansion-panel-header-content.component';
import { DlsAvatarModule } from '@zelis/dls/avatar';
import { DlsButtonModule } from '@zelis/dls/button';
import { ExpansionPanelDirective } from './expansion-panel/expansion-panel.directive';
import { AccordionDirective } from './accordion/accordion.directive';
import { ExpansionPanelComponent } from './expansion-panel-component/expansion-panel.component';

@NgModule({
  imports: [
    CommonModule,
    MatExpansionModule,
    DlsIconModule,
    MatIconModule,
    DlsAvatarModule,
    DlsButtonModule,
  ],
  declarations: [
    ExpansionPanelHeaderComponent,
    ExpansionPanelDirective,
    AccordionDirective,
    ExpansionPanelRightIconDirective,
    ExpansionPanelComponent,
  ],
  exports: [
    MatExpansionModule,
    ExpansionPanelHeaderComponent,
    ExpansionPanelDirective,
    AccordionDirective,
    DlsAvatarModule,
    DlsButtonModule,
    DlsIconModule,
    ExpansionPanelRightIconDirective,
    ExpansionPanelComponent,
  ],
})
export class DlsExpansionPanelModule {}
